<div class="height26">

    <table class="timesheettbl">
        <thead>
            <tr>
                <th>Date</th>
                <th>Comments</th>
                <th>Type</th>
                <th>Hours</th>
                <th>Status</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let item of timesheetdata; let i=index">
                <tr (click)="RowdataClick()" *ngIf="timesheetdata.length>0">
                    <td>
                        {{item.tsDate}}
                    </td>
                    <td style="width: 16rem;" title="{{ item.tsRemark }}">
                        <span class="timesheet-remarks">
                            {{item.tsRemark}}
                        </span>
                    </td>
                    <td>{{item.tstype}}</td>
                    <td>{{item.tshours}}</td>
                    <td>{{item.tsStatus}}</td>
                </tr>
            </ng-container>
            <tr (click)="RowdataClick()" *ngIf="timesheetdata.length==0">
                <td></td>
                <td> No data</td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>

</div>
<!-- <div class="timesheetstatus2 bold">
    <div> Date</div>
    <div> Remark</div>
    <div>Type</div>
    <div> Hours</div>
    <div> Status</div>
</div>

<div class="height26 scroller" *ngIf="timesheetdata.length>0">

    <ng-container *ngFor="let item of timesheetdata; let i=index">
        <div class="timesheetstatus2" (click)="RowdataClick()">
            <div>{{item.tsDate}}</div>
            <div>{{item.tsRemark}}</div>
            <div>{{item.tstype}}</div>
            <div>{{item.tshours}}</div>
            <div>{{item.tsStatus}}</div>
        </div>
    </ng-container>
</div>
<div class="height26 scroller" *ngIf="timesheetdata.length==0">
    <div (click)="RowdataClick()">
        <div class="timesheetstatus2">
            No data found
        </div>
    </div>
</div> -->